import { formatDateRange } from "@/utils/date";

const formatStageTemplate = function(stage) {
  return function (stage) {
    return Object.assign(document.createElement('span'), {
      innerHTML: stage.name + '<br><small style="opacity: 50%">' + formatDateRange(stage.start_at, stage.end_at) + '</small>'
    });
  }
}

export {
  formatStageTemplate
}